import lodash from 'lodash';
import { useContext, useEffect } from 'react';

import { RicosContext, SchemaContext } from './../../../ricos-context';
import { isSSR } from './../../../wix-rich-content-common';

import type { RicosTiptapEditorProps } from '../../types';
import { getSelectedNodes } from './get-selected-nodes';

export const useEditorSideEffects = ({
  editor,
  onUpdate,
  onSelectionUpdate,
}: {
  editor: RicosTiptapEditorProps['editor'];
  onUpdate: RicosTiptapEditorProps['onUpdate'];
  onSelectionUpdate: RicosTiptapEditorProps['onSelectionUpdate'];
}) => {
  const schema = useContext(SchemaContext);
  const { content } = useContext(RicosContext);

  useEffect(() => {
    editor.on(
      'update',
      lodash.debounce(
        () => {
          onUpdate?.({
            content: schema.getContent(),
          });
        },
        60,
        { leading: true }
      )
    );
    editor.on(
      'selectionUpdate',
      lodash.debounce(
        () => {
          const selectedNodes = getSelectedNodes({ editor });
          content.update(selectedNodes, editor);
          onSelectionUpdate?.({
            selectedNodes,
            content: schema.getContent(),
          });
        },
        60,
        { leading: true }
      )
    );

    if (!isSSR()) {
      //@ts-ignore
      window.tiptapEditor = editor;
    }
  }, []);
};
